<template>
  <div style="height: 100%">
    <Layout style="height: 100%;">
      <Sider style="background: #fff!important;" width="240" hide-trigger>
        <Menu @on-select="selectMenu" :active-name="menuSelect">
            <MenuGroup title="通用">
                <MenuItem name="chat">
                    <Icon type="md-document" />
                     在线聊天
                </MenuItem>
                <MenuItem name="team">
                    <Icon type="md-document" />
                     团队
                </MenuItem>
                
            </MenuGroup>
            
        </Menu>
      </Sider>
      <Layout>
        <Content style="padding: 0px 15px;">
          <div style="background: #fff;padding: 15px;height: calc(100% - 100px);padding-top: 50px;" class="container">
            
            <div v-show="menuSelect == 'chat'" class="content">
              
              <div class="item">
                <h3>会话分配</h3>
                <Divider style="margin-top: 12px;" />
                <RadioGroup v-model="configs.csr_distribution">
                  
                  <Row style="margin-bottom: 10px;">              
                    <Radio label="0">
                        <span style="font-size: 16px;color: #222;">按工作强度 <span style="font-size: 12px; color: #999;"> &nbsp;&nbsp;优先分配给当前接待量最少的客服,若有多个客服接待量相同,则分配给其中最久未进行接待的客服</span></span>
                    </Radio>
                  </Row>
                  <Row style="margin-bottom: 10px;">              
                    <Radio label="1">
                        <span style="font-size: 16px;color: #222;">智能分配 <span style="font-size: 12px; color: #999;"> &nbsp;&nbsp;根据接待上限和当前接待量，分配给最能接待的客服</span></span>
                    </Radio>
                  </Row>
                  <Row style="margin-bottom: 10px;">              
                    <Radio label="2">
                        <span style="font-size: 16px;color: #222;">轮流分配 <span style="font-size: 12px; color: #999;"> &nbsp;&nbsp;每次都分配给最久未进行接待的客服</span></span>
                    </Radio>
                  </Row>
                  
                </RadioGroup>
              </div>
              <div style="position: fixed;bottom: 0px;height: 100px;display: flex;align-items: center;width: 150px;">
                <Button @click="setKefuConfig" long size="large" type="primary">保存</Button>
              </div>
            </div>

            <div v-show="menuSelect == 'team'" class="">
              <Row style="padding-bottom: 20px;">
                  <Col span="12">
                      <DatePicker v-model="searchForm.date" type="daterange" placement="bottom-start" placeholder="日期" style="width: 200px"></DatePicker>
                      <Button @click="getCsrList" style="margin-left: 10px;" type="primary">提交</Button>
                  </Col>
                  
              </Row>
              <Table style="width: 100%;" :loading="loading" :columns="columns" :data="data" height="600">
                <template slot-scope="{ row }" slot="status">
                  <Badge v-if="row.status == 3" status="success" text="在线" />
                  <Badge v-if="row.status == 0" status="error" text="离线" />
                  <Badge v-if="row.status == 1" status="warning" text="繁忙" />
                  <Badge v-if="row.status == 2" status="error" text="离开" />
                </template>
                <template slot-scope="{ row }" slot="forget_replay_count">
                  <a @click="forgetReplyModalShow(row.id)" v-if="row.forget_replay_count > 0">{{row.forget_replay_count}}</a>
                  <span v-if="row.forget_replay_count == 0" >{{row.forget_replay_count}}</span>
                </template>
                <template slot-scope="{ row }" slot="is_recept">
                  {{row.is_recept}}
                  <Switch v-model="is_recept" @on-change="switchReceptable(row)" ></Switch>

                </template>
              </Table>
              <Row>              
                <div class="page-wrap">            
                  <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
                </div>
              </Row>
            </div>

          </div>
        </Content>
      </Layout>
    </Layout>
<Modal
    v-model="forgetReplyModal"
    title="遗漏回复"
    :footer-hide="true"
    width="80%">
    <ForgetReply ref="forgetReplyElem"></ForgetReply>
</Modal>
  </div>
</template>
<script>
import RequestUtils from "@/utils/RequestUtils";
import ForgetReply from "./forget_reply.vue";
import { formatDateTime } from "@/utils/ChatUtils";
import conf from "@/views/im/conf";

export default {
  components: {
    ForgetReply
  },

  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 10,
      configs: {},
      menuSelect: 'chat',
      loading: false,
      is_recept: true,
      forgetReplyModal: false,
      searchForm: {
        date: ''
      },
      columns: [
          {
              title: '用户名',
              key: 'username'
          },
          {
              title: '在线状态',
              slot: 'status'
          },
          {
              title: '接待上限',
              key: 'ceiling'
          },
          {
              title: '在线时长(近7天)',
              key: 'online_duration'
          },
          {
              title: '平均回复速度(近7天)',
              key: 'avg_reply_speed'
          },
          {
              title: '平均回复字数(近7天)',
              key: 'avg_word_num'
          },
          {
              title: '回复的客户数(近7天)',
              key: 'reply_session_count'
          },
          {
              title: '当前接待人数',
              key: 'reception_count'
          },
          {
              title: '遗漏消息',
              slot: 'forget_replay_count'
          },
          {
            title: '是否接待',
            key: 'is_recept',
            align: 'center',
            render: (h, params) => {
              return h(
                'i-Switch',
                {
                  props: {
                    size: 'large',
                    value: params.row.is_recept === 1
                  },
                  scopedSlots: {
                    open: () => h('span', '开启'),
                    close: () => h('span', '关闭')
                  },
                  on: {
                    'on-change': () => {
                      this.switchReceptable(params)
                    }
                  }
                }
              )
            }
          },

          {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },
  computed: {

  },
  methods: {
    switchReceptable(item) {
      let param = new FormData();
      param.set('csr_id', item.row.id );
      RequestUtils.request(conf.setCsrReceptable(), param)
      .then(() => {
        this.getKefuConfig();
      })
    },
    selectMenu(name) {
      if (name == 'team') {
        this.getCsrList();
      }
      this.menuSelect = name;
    },
    getKefuConfig () {
      let param = new FormData();
      RequestUtils.request(conf.getKefuConfig(), param)
      .then(data => {
        this.configs = data;
      })
    },
    setKefuConfig() {
      let param = new FormData();
      for (let i in this.configs) {      
        param.set(i, this.configs[i] );
      }
      RequestUtils.request(conf.setKefuConfig(), param)
      .then(() => {
        this.$Message.success('配置保存成功!');
        this.getKefuConfig();
      })
    },
    getCsrList () {
      let self = this;
      self.loading = true;
      let param = new FormData();
      param.set("page", this.curPage );
      param.set("limit", this.pageSize );
      if (this.searchForm.date[0] != '') {
        let date = formatDateTime(this.searchForm.date[0], 'YYYY-mm-dd')+' - '+formatDateTime(this.searchForm.date[1], 'YYYY-mm-dd');
        param.set("date",  date);
      }
      RequestUtils.request(conf.getCsrList(), param)
      .then(data => {
        self.data = data.data;
        self.total = data.total;
        self.loading = false;
      })
    },
    switchPage (index) {
      this.data = [];
      this.curPage = index;
      this.getCsrList();
    },
    switchPagesize (size) {
      this.curPage = 1;
      this.pageSize = size;
      this.getCsrList();
    },
    // 显示遗漏消息
    forgetReplyModalShow (csr_id) {
      this.forgetReplyModal = true;
      this.$refs.forgetReplyElem.curPage = 1;
      this.$refs.forgetReplyElem.filter.csr_id = csr_id;
      this.$refs.forgetReplyElem.request();
    }
  },
  created: function() {
    this.getKefuConfig();
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      margin-top: 4rem;
      padding: 1rem;
      
    }
  }

  
}
</style>
